import React from 'react';

import { Container } from './styles';

const NewScout: React.FC = () => (
  <Container>
    <div className="preview-banner" role="status">
      <div>
        <span className="eyebrow">NOVA EXPERIÊNCIA</span>
        <strong>Novo Scout</strong>
      </div>
      <p>
        Prévia para stakeholders. Dados fictícios e controles desativados; esta
        tela não é usada em operações reais.
      </p>
      <span className="preview-tag">SOMENTE VISUALIZAÇÃO</span>
    </div>

    <main className="scout-preview">
      <header className="event-heading">
        <div>
          <span className="eyebrow">EVENTO DE DEMONSTRAÇÃO</span>
          <h1>SCOUT CHAMPIONSHIP 08</h1>
        </div>
        <span className="fight-number">LUTA 03 · CARD PRINCIPAL</span>
      </header>

      <section className="fight-layout" aria-label="Prévia da tela de scout">
        <CornerPanel
          corner="red"
          name="Marina Costa"
          record="12 vitórias · 2 derrotas"
          stats={[
            { label: 'Golpes significativos', value: '38%' },
            { label: 'Quedas', value: '3 / 5' },
            { label: 'Tempo de controle', value: '04:12' },
          ]}
        />

        <section className="fight-center" aria-label="Estado da luta">
          <div className="timer">03:42</div>
          <div className="fight-status">2º ROUND · EM ANDAMENTO</div>
          <div className="fighters">
            <strong>MARINA COSTA</strong>
            <span>VS</span>
            <strong>JULIANA ALVES</strong>
          </div>
          <div className="state-row">
            <span className="state-label">POSIÇÃO</span>
            <strong>Em pé</strong>
            <span className="state-label">DOMÍNIO</span>
            <strong className="neutral">Neutro</strong>
          </div>
          <div className="round-picker">
            <span>Round selecionado</span>
            <button type="button" disabled aria-label="Round 2, desativado">
              Round 2
            </button>
          </div>
          <div className="legend" aria-label="Legenda de estados">
            <span>
              <i className="red-dot" />
              Canto vermelho
            </span>
            <span>
              <i className="blue-dot" />
              Canto azul
            </span>
            <span>
              <i className="green-dot" />
              Domínio
            </span>
          </div>
        </section>

        <CornerPanel
          corner="blue"
          name="Juliana Alves"
          record="9 vitórias · 1 derrota"
          stats={[
            { label: 'Golpes significativos', value: '52%' },
            { label: 'Quedas', value: '1 / 3' },
            { label: 'Tempo de controle', value: '01:36' },
          ]}
        />
      </section>

      <section className="action-log" aria-labelledby="action-log-title">
        <div className="section-heading">
          <div>
            <span className="eyebrow">ACOMPANHAMENTO</span>
            <h2 id="action-log-title">Ações da luta</h2>
          </div>
          <span className="sample-label">EXEMPLO ESTÁTICO</span>
        </div>
        <ol>
          <li className="red-action">
            <time>03:31</time>
            <strong>Marina Costa</strong>
            <span>Golpe significativo · cabeça</span>
          </li>
          <li className="blue-action">
            <time>03:18</time>
            <strong>Juliana Alves</strong>
            <span>Chute significativo · perna</span>
          </li>
          <li className="red-action">
            <time>02:54</time>
            <strong>Marina Costa</strong>
            <span>Tentativa de queda</span>
          </li>
        </ol>
      </section>

      <footer className="preview-footer">
        <span>PRÉVIA DE DESENVOLVIMENTO</span>
        <span>Nenhuma ação será salva ou enviada.</span>
      </footer>
    </main>
  </Container>
);

interface CornerPanelProps {
  corner: 'red' | 'blue';
  name: string;
  record: string;
  stats: { label: string; value: string }[];
}

const CornerPanel: React.FC<CornerPanelProps> = ({
  corner,
  name,
  record,
  stats,
}) => (
  <section className={`corner-panel ${corner}`} aria-label={`Canto ${corner}`}>
    <header>
      <span className="corner-label">
        {corner === 'red' ? 'CANTO VERMELHO' : 'CANTO AZUL'}
      </span>
      <h2>{name}</h2>
      <p>{record}</p>
    </header>
    <div className="metric-list">
      {stats.map((stat) => (
        <div className="metric" key={stat.label}>
          <span>{stat.label}</span>
          <strong>{stat.value}</strong>
          <div className="metric-track" aria-hidden="true">
            <i />
          </div>
        </div>
      ))}
    </div>
    <div className="disabled-actions" aria-label="Ações desativadas">
      <button type="button" disabled>Golpe</button>
      <button type="button" disabled>Queda</button>
      <button type="button" disabled>Defesa</button>
    </div>
  </section>
);

export default NewScout;